<ngx-spinner type="ball-spin-clockwise" bdColor="rgba(0,0,0,0.6)" color="#ffffff" size="medium">
  <img src="/assets/images/eg-insurtech-logo.png" alt="" />
</ngx-spinner>

<router-outlet />
